import { UploadedFile } from "../types";
import { Box, Stack, Text, TextLink } from "@origin-digital/ods-core";
import * as React from "react";
import { mapKeyToDocumentTypeLabel } from "../helper";
import { IconNewWindow } from "@origin-digital/ods-icons";

const ReadOnlyUploadedFile = ({ attachment }: { attachment: UploadedFile }) => {
  const { name, fileType, link } = attachment;
  const label = mapKeyToDocumentTypeLabel(fileType);
  return (
    <Stack space="xxsmall">
      {label && <Text weight="medium">{label}</Text>}
      <Text wordBreak>
        {link ? (
          <TextLink href={link}>
            {name}
            <Box display="inline" paddingLeft="xxsmall">
              <IconNewWindow color="inherit" size="inherit" />
            </Box>
          </TextLink>
        ) : (
          name
        )}
      </Text>
    </Stack>
  );
};

export default ReadOnlyUploadedFile;
